import RegionCell from './RegionCell';

export default RegionCell;
